import {useCallback, useMemo} from 'react';

import {PeopleRoofRegularIcon} from 'shells/icon/svg/people-roof-regular-icon';

import {EditableLabelField} from '../../shared/header/edit-fields/editable-label-field';

interface Props {
    employeeCount: string | null | undefined;
    onUpdateAccountEmployeeCount: (employeeCount: number) => Promise<any>;
}

export function AccountEmployeeCountField(props: Props) {
    const {employeeCount, onUpdateAccountEmployeeCount} = props;
    const formattedEmployeeCount = useMemo(() => {
        if (!employeeCount) {
            return '';
        }

        const parsedEmployeeCount = Number(employeeCount);
        if (Number.isNaN(parsedEmployeeCount)) {
            return '';
        }

        return parsedEmployeeCount.toLocaleString();
    }, [employeeCount]);

    const editableEmployeeCount = employeeCount ?? '';

    const handleSaveEmployeeCount = useCallback(
        (newValue: string) => {
            const normalizedValue = newValue.replace(/[^0-9]/g, '');
            const parsedEmployeeCount = Number(normalizedValue);

            if (!normalizedValue.length || Number.isNaN(parsedEmployeeCount)) {
                return Promise.reject(new Error('Invalid employee count value'));
            }

            return onUpdateAccountEmployeeCount(parsedEmployeeCount);
        },
        [onUpdateAccountEmployeeCount]
    );

    return (
        <EditableLabelField
            icon={PeopleRoofRegularIcon}
            label='Number of employees'
            value={formattedEmployeeCount}
            editValue={editableEmployeeCount}
            onSaveNewValue={handleSaveEmployeeCount}
            placeholder='0'
            tooltip={formattedEmployeeCount || '0'}
        />
    );
}
